exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#categoria[data-v-fe1dff74]{background-image:url(/public/images/site/categoria.svg);background-repeat:no-repeat;padding-top:100px;background-size:100%;text-align:-webkit-center;display:table;position:relative;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe1dff74","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/ActivitiesCategory.vue
// module id = 570
// module chunks = 0